import React from "react";
import Marquee from "react-fast-marquee";

const NewsTicker = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px", margin: "auto" }}>
      
      {/* First Marquee (Slow Speed) */}
      <Marquee pauseOnHover={true} speed={50} gradient={true} gradientWidth={50}>
        <span style={{ marginRight: "30px", fontWeight: "bold", color: "#004080" }}>
          🏠 Quality Home Care Services Available Now!
        </span>
        <span style={{ marginRight: "30px", fontWeight: "bold", color: "#004080" }}>
          ❤️ Trusted Senior Care Assistance!
        </span>
      </Marquee>

      {/* Second Marquee (Medium Speed) */}
     

      {/* Third Marquee (Fast Speed) */}
     

    </div>
  );
};

export default NewsTicker;
